import { EntitySponsor } from "../../entity/EntitySponsor";

export class DtoSponsorsPostRes extends EntitySponsor {}
